import React, { createContext, useContext, useState, useEffect } from 'react';
import { Language } from '../i18n/translations';

interface LanguageContextType {
    language: Language;
    setLanguage: (lang: Language) => void;
}

const LanguageContext = createContext<LanguageContextType | undefined>(undefined);

export const LanguageProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const [language, setLanguageState] = useState<Language>(() => {
        // Get from localStorage or default to Russian
        if (typeof window !== 'undefined') {
            const saved = localStorage.getItem('lingwise_lang');
            if (saved === 'en' || saved === 'ru') {
                return saved;
            }
        }
        return 'ru';
    });

    useEffect(() => {
        localStorage.setItem('lingwise_lang', language);
    }, [language]);

    const setLanguage = (lang: Language) => {
        setLanguageState(lang);
    };

    return (
        <LanguageContext.Provider value={{ language, setLanguage }}>
            {children}
        </LanguageContext.Provider>
    );
};

export const useLanguage = () => {
    const context = useContext(LanguageContext);
    if (!context) {
        throw new Error('useLanguage must be used within LanguageProvider');
    }
    return context;
};
